var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cashflow-app"},[(_vm.cashflowBarState)?_c('cashflow-state-bar',{attrs:{"bar-state":_vm.cashflowBarState}}):(_vm.canceled)?_c('failed-payment-bar',{attrs:{"cta-type":'go-to-settings'}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }